import { Methods } from "@newview/infrastructure";
import { NewviewOaBaseApi } from "./NewviewOaBaseApi";


export class BiddingPlatformApi extends NewviewOaBaseApi {

    public get ControllerName(): any {
        return 'bidding-platform'
    }


 

}